import { render, staticRenderFns } from "./RequestUnsubscribe.vue?vue&type=template&id=0a7b08d7&"
import script from "./RequestUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./RequestUnsubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports